import { useContext, useMemo, useState } from "react"
import { ReactComponent as PEOPLE } from "../../../assets/People.svg"
import { ReactComponent as TASKS } from "../../../assets/Task.svg"
import { ReactComponent as CHECK } from "../../../assets/CheckCircle.svg"
import BaseInputField from "../../../components/elements/BaseInputField"
import BaseInputSelection from "../../../components/elements/BaseInputSelection"
import BaseModal from "../../../components/layout/BaseModal"
import { ModalContext } from "../../../components/contexts/ModalContext"
import { Tour, TourEmployeeRef } from "../types"
import TourActiveToggle from "./TourActiveToggle"

type EditTourModalType = {
    modalId: number
    tour: Tour
    employees: TourEmployeeRef[]
    employeesLoading: boolean
    onSearchEmployee: (search: string) => void
    onSave: (data: { name: string; employee?: TourEmployeeRef; active: boolean }) => void
}

export default function EditTourModal(props: EditTourModalType) {
    const modalCon = useContext(ModalContext)
    const [name, setName] = useState(props.tour.name)
    const [employeeId, setEmployeeId] = useState(props.tour.employee?._id ?? "")
    const [pickedEmployee, setPickedEmployee] = useState<TourEmployeeRef | undefined>(props.tour.employee)
    const [active, setActive] = useState(props.tour.active)

    const employees = useMemo(() => {
        const list = props.employees ?? []
        if (pickedEmployee && !list.some((item) => item._id === pickedEmployee._id)) return [pickedEmployee, ...list]
        return list
    }, [props.employees, pickedEmployee])

    const syncFromTour = () => {
        setName(props.tour.name)
        setEmployeeId(props.tour.employee?._id ?? "")
        setPickedEmployee(props.tour.employee)
        setActive(props.tour.active)
    }

    const setEmployee = (id: string) => {
        setEmployeeId(id)
        if (!id) {
            setPickedEmployee(undefined)
            return
        }
        setPickedEmployee(employees.find((item) => item._id === id) ?? pickedEmployee)
    }

    return (
        <BaseModal
            modalId={props.modalId}
            size="small"
            title="Tour bearbeiten"
            onOpen={syncFromTour}
            bottomRow={
                <div className="flex justify-end w-full">
                    <button
                        className="btn btn-primary"
                        type="button"
                        disabled={!name.trim()}
                        onClick={() => {
                            props.onSave({ name: name.trim(), employee: employeeId ? pickedEmployee : undefined, active })
                            modalCon?.trigger(props.modalId)
                        }}>
                        Speichern
                    </button>
                </div>
            }>
            <div className="flex flex-col gap-4 px-2 pt-4 pb-2">
                <div className="flex gap-3 items-start">
                    <TASKS className="w-6 h-6 shrink-0 mt-8 text-primary" />
                    <BaseInputField label="Name *" type="text" value={name} onChange={setName} placeholder="z. B. Chemnitz Nord" />
                </div>
                <div className="flex gap-3 items-start">
                    <PEOPLE className="w-6 h-6 shrink-0 mt-8 text-primary" />
                    <BaseInputSelection
                        label="Mitarbeiter (Live-Zuordnung)"
                        placeholder="Nicht zugewiesen"
                        data={employees}
                        value={employeeId || undefined}
                        setId={setEmployee}
                        onSearch={props.onSearchEmployee}
                        customLoading={props.employeesLoading}
                        allowClear
                    />
                </div>
                <div className="flex gap-3 items-start">
                    <CHECK className="w-6 h-6 shrink-0 mt-8 text-primary" />
                    <TourActiveToggle active={active} onChange={setActive} />
                </div>
            </div>
        </BaseModal>
    )
}
